import _, { filter } from 'lodash';

export default function reducer(
  state = {
    AddType: 'company',
    Type: 'company',
    query: '',
    filters: {},
    sorting: {
      column: 'dueDate',
      order: 'desc',
    },
    Count: {},
    Filter: {
      projectProgress: 'All',
      projectNameSort: 'asc',
      projectType: 1,
      typeId: 1,
      isActive: 1,
      search: '',
    },
    activeStatus: [],
    FormActive: 'List',
    List: [],
    userProjectList: {
      company: [],
      project: [],
    },
    Profile: {
      List: [],
      Count: {},
      HasNextPage: true,
      Page: 0,
    },
    Loading: 'RETRIEVING',
    ProjectManagerId: '',
    Selected: { isActive: 1 },
    StatusCount: [],
    SelectedId: [],
    SelectList: [],
    Category: {
      Client: {
        list: [],
        count: {},
        loading: 'RETRIEVING',
      },
      Internal: {
        list: [],
        count: {},
        loading: 'RETRIEVING',
      },
      Private: {
        list: [],
        count: {},
        loading: 'RETRIEVING',
      },
      Active: '',
    },
    Page: 0,
    HasNextPage: true,
    Inactive: null,
    NewProjectAdded: null,
    refetch: false,
    // Creation permissions from /api/me. Default-deny until the call resolves
    // so the "New company/project" button never flashes for users who can't create.
    permissions: {
      canCreateCompany: false,
      canCreateProject: false,
    },
  },
  action
) {
  switch (action.type) {
    case 'SET_USER_TYPE': {
      return {
        ...state,
        userType: action.userType,
      };
    }
    case 'SET_ME_PERMISSIONS': {
      return {
        ...state,
        permissions: action.permissions,
      };
    }
    case 'SET_USER_PROJECT_LIST': {
      // action.projectType should be 'company' or 'project'
      const type = action.projectType || 'project';
      return {
        ...state,
        userProjectList: {
          ...state.userProjectList,
          [type]: action.list || [],
        },
      };
    }
    case 'SET_PROJECT_ADD_TYPE': {
      return {
        ...state,
        AddType: action.addType,
      };
    }
    case 'SET_PROJECT_LIST': {
      return {
        ...state,
        List: action.list,
        ...(typeof action.count !== 'undefined' ? { Count: action.count } : {}),
        ...(typeof action.hasNextPage !== 'undefined'
          ? { HasNextPage: action.hasNextPage }
          : {}),
        ...(action.page ? { Page: action.page } : {}),
      };
    }
    case 'SET_PROJECT_PROFILE_LIST': {
      return {
        ...state,
        Profile: {
          ...state.Profile,
          List: action.list,
          ...(typeof action.count !== 'undefined'
            ? { Count: action.count }
            : {}),
          ...(typeof action.hasNextPage !== 'undefined'
            ? { HasNextPage: action.hasNextPage }
            : {}),
          ...(action.page ? { Page: action.page } : {}),
        },
      };
    }
    case 'SET_PROJECT_STATUS_COUNT': {
      return { ...state, StatusCount: action.count };
    }
    case 'SET_PROJECT_FORM_ACTIVE': {
      return { ...state, FormActive: action.FormActive };
    }
    case 'SET_PROJECT_SELECTED': {
      return { ...state, Selected: { ...state.Selected, ...action.Selected } };
    }
    case 'SET_PROJECT_ID': {
      return { ...state, SelectedId: action.SelectedId };
    }
    case 'SET_PROJECT_MANAGER_ID': {
      return { ...state, ProjectManagerId: action.id };
    }
    case 'SET_PROJECT_LOADING': {
      return { ...state, Loading: action.Loading };
    }
    case 'UPDATE_DATA_PROJECT_LIST': {
      let newList = state.List.map((e, i) => {
        if (e.id === action.UpdatedData.id) {
          return action.UpdatedData;
        }
        return e;
      });
      return { ...state, List: newList };
    }
    case 'REMOVE_DELETED_PROJECT_LIST':
    case 'ARCHIVE_PROJECT': {
      const { List } = { ...state };
      const updatedList = filter(List, (o) => {
        return o.id !== action.id;
      });

      return { ...state, List: updatedList };
    }
    // case "REMOVE_DELETED_PROJECT_LIST": {
    //     const { List } = { ...state };
    //     const updatedList = filter(List, o => {
    //         return o.id !== action.id;
    //     });

    //     return { ...state, List: updatedList };
    // }
    case 'SET_PROJECT_STATUS': {
      let List = state.List.map((e, i) => {
        if (e.id === action.record.id) {
          e.Active = action.record.status;
          return e;
        } else {
          return e;
        }
      });
      return { ...state, List: List };
    }
    case 'SET_PROJECT_FILTER': {
      const { Filter } = { ...state };
      const updatedFilter = _.merge({}, Filter, action.filter);
      return { ...state, Filter: updatedFilter };
    }
    case 'SET_PROJECT_SELECT_LIST': {
      return { ...state, SelectList: action.List };
    }
    case 'SET_PROJECT_CATEGORY': {
      return {
        ...state,
        Category: { ...state.Category, [action.category]: action.data },
      };
    }
    case 'SET_PROJECT_ACTIVE_CATEGORY': {
      return {
        ...state,
        Category: { ...state.Category, Active: action.ActiveCategory },
      };
    }
    case 'RESET_PROJECT': {
      return { ...state, ...action };
    }
    case 'UPDATE_PROJECT_QUERY': {
      return { ...state, query: action.query };
    }
    case 'SET_PROJECT_TYPE': {
      return { ...state, Type: action.projectType };
    }
    case 'SET_PROJECT_INACTIVE': {
      return { ...state, Inactive: action.project };
    }
    case 'SET_PROJECT_NEWLY_ADDED': {
      return { ...state, NewProjectAdded: action.boolean };
    }
    case 'SET_PROJECT_SORTING':
      return {
        ...state,
        sorting: action.sorting,
      };
    case 'SET_PROJ_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.column]: action.filters,
        },
      };
    case 'RESET_PROJECT_FILTERS':
      return {
        ...state,
        filters: {},
      };
    case 'SET_ACTIVE_STATUS':
      return {
        ...state,
        activeStatus: action.status,
      };
    case 'SET_PROJECT_REFETCH':
      return { ...state, NewProjectAdded: action.boolean };
    case 'SET_USER_PROJECTS': {
      return {
        ...state,
        userProjectList: {
          ...state.userProjectList,
          project: action.projects, // Replace the project list with the API response
        },
      };
    }
    default:
      return state;
  }
}
